export default "__VITE_ASSET__x50vbUAq__"